<template lang="html">
  <div class="side-projects"
  data-aos="fade-left"
  data-aos-easing="ease-out-quad"
  data-aos-duration="250">
    <div class="fun-projects">
      <h1>Fun Projects</h1>
      <hr>
      <div class="projects">
        <div class="project-details">
          <div class="projects-detail">
              <img src="../assets/winter-projects/finlast/finlast-gif.gif" alt="">
            <h2>Finlast - Stocks/Crypto information and news. </h2>
            <p>Finance website to find information about trending stocks and crytpocurrencies.</p>
          </div>
          <div class="projects-detail">
              <img src="../assets/winter-projects/movieland/movieland-userflow-4.gif" alt="">
            <h2>Movieland</h2>
            <p>Find out the interest over time for different movies and TV shows.</p>
          </div>
          <div class="projects-detail">
              <img src="../assets/winter-projects/picturamafx/create-landing-cover.gif" alt="">
            <h2>Picturamafx</h2>
            <p>Find a photo you like and create a landing cover.</p>
            <p></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">

.side-projects {
  margin-bottom: 100px;
}

.project-details {
  text-align: center;
  display: grid;
  grid-template-columns: 50% 50%;

  .projects-detail {
    padding: 10px;
  }


  img {
    border-radius: 5px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
    border: none;
    width: 100%;
  }
}

@media only screen and (max-width: 900px) {
  .project-details {
      text-align: center;
      display: grid;
      grid-template-columns: 100%;
  }
}

</style>
